import { useLocation, useSearchParams } from 'react-router-dom';

import { isDesktopApp } from '@frontend/utils/desktop';
import { INSTANCE_ID_QUERY_PARAM_KEY, LOCAL_STORAGE_INSTANCE_ID_KEY } from '@frontend/utils/misc';

import { useLocalstorageParam } from './useLocalstorageParam';

const useInstanceId = () => {
  const [localInstanceId, setLocalInstanceId] = useLocalstorageParam(LOCAL_STORAGE_INSTANCE_ID_KEY);
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const instanceIdInQuery = searchParams.get(INSTANCE_ID_QUERY_PARAM_KEY);
  const locationParts = location.pathname.split('/');
  const instanceIdInPath =
    locationParts.length > 2 && locationParts[1] === 'instances' ? locationParts[2] : null;

  const instanceIdInUrl = instanceIdInQuery || instanceIdInPath;

  // Read localStorage synchronously as the final fallback so the persisted
  // instance is available on the very first render. The atom (localInstanceId)
  // hydrates only via an effect that runs after render, which is too late for
  // the root-path redirect — without this, every visit to "/" lands on the
  // instance selector even though opal:instanceId is already persisted.
  const instanceIdToUse = isDesktopApp()
    ? instanceIdInUrl
    : instanceIdInUrl || localInstanceId || localStorage.getItem(LOCAL_STORAGE_INSTANCE_ID_KEY);

  if (!isDesktopApp() && instanceIdInUrl && localInstanceId !== instanceIdInUrl) {
    setLocalInstanceId(instanceIdInUrl);
  }

  return { instanceId: instanceIdToUse };
};

export { useInstanceId };
